import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// گارد مسیر /admin: باید هم لاگین‌شده باشد و هم user.is_admin === true.
const AdminRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user?.is_admin) {
    return (
      <div className="flex items-center justify-center min-h-[60vh] text-center p-6" dir="rtl">
        <div className="max-w-md">
          <div className="text-4xl mb-3">🔒</div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">دسترسی محدود</h2>
          <p className="text-slate-500">این بخش فقط برای مدیر در دسترس است.</p>
        </div>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
